 import { registerService } from '@shared/services/register';
import { notifySuccess, notifyError } from '@config/tostifyConfig/tostifyConfig';
import { t } from 'i18next';


const getErrorMessage = (err, defaultMsg = 'Грешка') => {
    const data = err?.response?.data;
    return typeof data === 'string' ? data : data?.message ?? err?.message ?? defaultMsg;
};

export const approveNoiNotify = async (parId, { defaultErrorMessage } = {}) => {
    if (!parId) return;
    try {
        await registerService.patchNoiNotify(parId);
        notifySuccess('Успешно представяне в НАП');
    } catch (err) {
        notifyError(getErrorMessage(err, defaultErrorMessage));
    }
};

export const confirmNoiNotify = async (parId, { defaultErrorMessage } = {}) => {
    if (!parId) return;
    try {
        await registerService.patchNoiNotifyConfirm(parId);
        notifySuccess(t('common.operationSuccessfully'));
    } catch (err) {
        notifyError(getErrorMessage(err, defaultErrorMessage));
    }
};

export const exportNoiNotify = async (parId, { defaultErrorMessage } = {}) => {
    if (!parId) return;
    try {
        await registerService.postNoiNotifyExportNra(parId);
        notifySuccess(t('common.operationSuccessfully'));
    } catch (err) {
        notifyError(getErrorMessage(err, defaultErrorMessage));
    }
};

export const formationNoiNotify = async (refetch, { defaultErrorMessage, excludedType } = {}) => {
    try {
        await registerService.postNoiNotify({ excludedType: excludedType });
        await refetch();
    } catch (err) {
        notifyError(getErrorMessage(err, defaultErrorMessage));
    }
};

export const fetchNoiNotifies = async (params = {}) => {
    try {
        const response = await registerService.getNoiNotifies(params);
        return response;
    } catch (error) {
        console.error('Error fetching noi notifies', error);
        return { content: [], totalPages: 0, totalElements: 0 };
    }
};

export const openReport = (parId) => {
    if (!parId) return;
    const url = `/personnel/employment-contracts/nra-reports?parId=${parId}`;
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const navigateToNraReportsTable = (navigate) => {
    navigate('/personnel/employment-contracts/nra-reports-table');
};
